import { ModaSofa } from '@dora/backpack';
import { Defaults } from './defaults';
import { pipe } from 'fp-ts/lib/function';
import * as O from 'fp-ts/Option';

export type SofaConfigureSeatCount = {
    middleSeats: number;
    leftSeats: number;
    rightSeats: number;
    straightSeats: number;
};

/** produce a NumberOfSeats from a number which may not exist */
const seatWithDefault = (n: number | undefined, endSeatCount: number, def: number) =>
    pipe(
        n,
        O.fromNullable,
        O.map(x => x + endSeatCount),
        O.filter(x => x > 0),
        O.fold(
            () => def,
            x => x,
        ),
    );

/** Construct the values of each seat setting
 */
export const numberOfSeatsFromSize =
    (seatsPerEndPieceL: number, seatsPerEndPieceR: number, seatsPerStraightPiece: number) =>
    (defaults: Defaults) =>
    (
        size: {
            left?: number;
            middle?: number;
            right?: number;
        },
        shape: ModaSofa.Shape,
    ): SofaConfigureSeatCount => {
        if (seatsPerStraightPiece !== 1) {
            /** TODO: handle case where straight seats per piece is not one if it ever comes up */
            throw new Error(
                'a straight sofa piece does not have a seat size of one - this is not currently supported',
            );
        }
        const middleSeats = seatWithDefault(size.middle, 0, defaults.middleSeats);
        const leftSeats = seatWithDefault(size.left, seatsPerEndPieceL, defaults.leftSeats);
        const rightSeats = seatWithDefault(size.right, seatsPerEndPieceR, defaults.rightSeats);

        const straightSeats = seatWithDefault(
            shape === 'straight' ? size.middle : undefined,
            seatsPerEndPieceL + seatsPerEndPieceR,
            defaults.seats,
        );

        return { middleSeats, leftSeats, rightSeats, straightSeats };
    };
